import { render, staticRenderFns } from "./AchievementAdd.vue?vue&type=template&id=381f5631&"
import script from "./AchievementAdd.vue?vue&type=script&lang=js&"
export * from "./AchievementAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports